import DisplayDensityMode from 'owa-service/lib/contract/DisplayDensityMode';
import { displayDensityOptionSelected } from '../actions/internalActions';
import { observer } from 'mobx-react';
import { OptionQuickCustomRenderComponentProps } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import * as React from 'react';
import strings from 'owa-strings/owa-options-strings';
import saveDensityOptionQuickSettings from '../actions/saveDensityOptionQuickSettings';
import { FocusZone } from 'office-ui-fabric-react/lib/FocusZone';
import { KeyCodes } from '@uifabric/utilities/lib';

const FULL_SELECTED_SVG = require('./imgs/fullSelected.svg');
const FULL_NOT_SELECTED_SVG = require('./imgs/fullNotSelected.svg');
const MEDIUM_SELECTED_SVG = require('./imgs/mediumSelected.svg');
const MEDIUM_NOT_SELECTED_SVG = require('./imgs/mediumNotSelected.svg');
const COMPACT_SELECTED_SVG = require('./imgs/compactSelected.svg');
const COMPACT_NOT_SELECTED_SVG = require('./imgs/compactNotSelected.svg');

const styles = require('./DisplayDensityQuick.scss');

@observer
export default class DisplayDensityQuick extends React.Component<
    OptionQuickCustomRenderComponentProps,
    {}
> {
    render() {
        const densityModeSelected = getUserConfiguration().UserOptions.DisplayDensityMode;

        let fullImgURI = FULL_NOT_SELECTED_SVG;
        let mediumImgURI = MEDIUM_NOT_SELECTED_SVG;
        let compactImgURI = COMPACT_NOT_SELECTED_SVG;
        let fullImageStyles = styles.disabled;
        let mediumImageStyles = styles.disabled;
        let compactImageStyles = styles.disabled;

        if (densityModeSelected === 'Simple') {
            mediumImgURI = MEDIUM_SELECTED_SVG;
            mediumImageStyles = styles.selected;
        } else if (densityModeSelected === 'Compact') {
            compactImgURI = COMPACT_SELECTED_SVG;
            compactImageStyles = styles.selected;
        } else {
            fullImgURI = FULL_SELECTED_SVG;
            fullImageStyles = styles.selected;
        }

        return (
            <FocusZone className={styles.densityOptionsContainer} role="listbox">
                {this.renderDensityOption(
                    'Full',
                    fullImgURI,
                    fullImageStyles,
                    strings.options_density_modeFull,
                    densityModeSelected
                )}
                {this.renderDensityOption(
                    'Simple',
                    mediumImgURI,
                    mediumImageStyles,
                    strings.options_density_modeMedium,
                    densityModeSelected
                )}
                {this.renderDensityOption(
                    'Compact',
                    compactImgURI,
                    compactImageStyles,
                    strings.options_density_modeCompact,
                    densityModeSelected
                )}
            </FocusZone>
        );
    }

    private renderDensityOption(
        densityOption: DisplayDensityMode,
        densityImageUri: any,
        densityImageStyles: any,
        stringForDensityOption: string,
        densityModeSelected: DisplayDensityMode
    ): JSX.Element {
        const ariaDensityString =
            strings.options_density_quickSetting_label + stringForDensityOption;
        return (
            <div
                className={styles.displayImageWithText}
                onClick={ev => this.densityImageClick(ev, densityOption)}
                onKeyDown={ev => this.densityImageClick(ev, densityOption)}
                data-is-focusable="true"
                role="option"
                aria-label={ariaDensityString}
                aria-selected={densityOption === densityModeSelected}>
                <div className={densityImageStyles}>
                    <img className={styles.image} src={densityImageUri} />
                </div>
                {stringForDensityOption}
            </div>
        );
    }
    private densityImageClick = (ev: any, displayOption: DisplayDensityMode) => {
        if (ev.type === 'click' || (ev.type === 'keydown' && ev.keyCode === KeyCodes.enter)) {
            ev.stopPropagation();
            displayDensityOptionSelected(displayOption);
            saveDensityOptionQuickSettings();
        }
    };
}
